module.exports = __webpack_public_path__ + "static/img/图层 23.5fe2a090.png";